import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Badge } from '../ui/badge';
import { API, gbp, adminHeaders } from '../../lib/shop';

const STATUS_COLORS = { paid: 'bg-green-500', dispatched: 'bg-blue-500', delivered: 'bg-gray-700', initiated: 'bg-amber-500', expired: 'bg-gray-400', failed: 'bg-red-500', cancelled: 'bg-red-400', refunded: 'bg-purple-500' };

export const AdminOrders = () => {
  const [orders, setOrders] = useState([]);

  const load = () => axios.get(`${API}/shop/admin/orders`, { headers: adminHeaders() }).then(r => setOrders(r.data)).catch(() => toast.error('Failed to load orders'));
  useEffect(() => { load(); }, []);

  const setStatus = async (o, status) => {
    try {
      await axios.patch(`${API}/shop/admin/orders/${o.id}/status?status=${status}`, null, { headers: adminHeaders() });
      toast.success(`Order ${o.order_number} marked ${status}`);
      load();
    } catch { toast.error('Update failed'); }
  };

  if (orders.length === 0) return <p className="text-gray-600" data-testid="admin-orders-empty">No orders yet.</p>;

  return (
    <div className="space-y-4" data-testid="admin-orders">
      {orders.map(o => (
        <div key={o.id} className="bg-white rounded-xl border border-gray-200 p-4" data-testid={`admin-order-${o.order_number}`}>
          <div className="flex flex-wrap justify-between items-start gap-2 mb-3">
            <div>
              <p className="font-bold text-gray-900">{o.order_number} <span className="text-gray-400 font-normal text-sm ml-2">{new Date(o.created_at).toLocaleString('en-GB')}</span></p>
              <p className="text-sm text-gray-600">{o.customer.name} · <a href={`mailto:${o.customer.email}`} className="hover:text-pink-600">{o.customer.email}</a> · <a href={`tel:${o.customer.phone}`} className="hover:text-pink-600">{o.customer.phone}</a></p>
              <p className="text-sm text-gray-600">{o.customer.address.line1}{o.customer.address.line2 ? `, ${o.customer.address.line2}` : ''}, {o.customer.address.city} {o.customer.address.postcode}</p>
              {o.customer.notes && <p className="text-sm text-gray-500 italic">Note: {o.customer.notes}</p>}
            </div>
            <div className="text-right">
              <Badge className={`${STATUS_COLORS[o.status] || 'bg-gray-500'} text-white`}>{o.status.toUpperCase()}</Badge>
              <p className="font-bold text-gray-900 mt-1">{gbp(o.total)}</p>
            </div>
          </div>
          <ul className="text-sm text-gray-700 mb-3">
            {o.items.map((i, idx) => <li key={idx}>{i.name} × {i.quantity} — {gbp(i.price * i.quantity)}</li>)}
          </ul>
          {o.emails && (
            <p className="text-xs mb-3">
              {o.emails.business_sent ? <span className="text-green-600">Emails sent</span> : <span className="text-amber-600">Email not sent: {o.emails.error}</span>}
            </p>
          )}
          {['paid', 'dispatched'].includes(o.status) && (
            <div className="flex gap-2">
              {o.status === 'paid' && <button onClick={() => setStatus(o, 'dispatched')} className="text-sm px-3 py-1 rounded-full bg-blue-50 text-blue-700 hover:bg-blue-100" data-testid={`admin-order-dispatch-${o.order_number}`}>Mark dispatched</button>}
              {o.status === 'dispatched' && <button onClick={() => setStatus(o, 'delivered')} className="text-sm px-3 py-1 rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200">Mark delivered</button>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
